import React from 'react'
import PropTypes from 'prop-types'
import { Box } from 'theme-ui'
import getImageVariant from '@components/utils/getImageVariant'

const styles = {
  imageWrapperSimple: {
    bg: `omegaLight`,
    display: `inline-block`,
    verticalAlign: `middle`,
    borderRadius: `full`,
    borderStyle: `solid`,
    borderWidth: `md`,
    borderColor: `omegaLight`,
    overFlow: `hidden`,
    opacity: 0.9,
    mr: 3,
    ':hover': {
      opacity: 1
    },
    '> div': {
      borderRadius: `full`
    }
  }
}

const AvatarSimple = ({ avatar, size, alt }) => {
  let image;
  if (process.env.GATSBY_CONTENTFUL_LOCAL) {
    image = avatar.localFile_ImageFluid.childImageSharp.fluid
  }  else {
    image = avatar && getImageVariant(avatar, "ImageFluid")
  }
  if (!image) return null
  return (
    <Box sx={styles.imageWrapperSimple}>
      <amp-img
        layout="responsive"
        srcset={image.srcSet}
        src={image.src}
        width={image.width || 48}
        height={image.height || 48}
        alt={alt}
      />
    </Box>
  )
}

export default AvatarSimple

AvatarSimple.defaultProps = {
  size: 'regular'
}

AvatarSimple.propTypes = {
  size: PropTypes.oneOf([false, 'small', 'regular']),
  loading: PropTypes.string,
  alt: PropTypes.string
}
